import { c as _c } from "react/compiler-runtime";
import { Avatar, HStack, VStack, Text, type StackProps } from '@chakra-ui/react';
import { Icon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';
interface OfficeHoursCardProps {
  personFullName?: string;
  personFirstName?: string;
  personLastName?: string;
  personTitle?: string;
  personAvatarUrl?: string;
  companyName?: string;
  quote: string;
  color?: string;
  id?: string;
  stackProps?: StackProps;
}
const OfficeHoursCard: React.FC<OfficeHoursCardProps> = t0 => {
  const $ = _c(57);
  const {
    personFullName,
    personFirstName,
    personLastName,
    personTitle,
    personAvatarUrl,
    companyName,
    quote,
    color,
    id,
    stackProps
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([4, 8]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([4, 8]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 8]);
    $[4] = getBreakpointValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== color || $[7] !== t3) {
    t4 = <Icon as={FaQuoteLeft} boxSize={t3} color={color} />;
    $[6] = color;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== getBreakpointValue) {
    t5 = getBreakpointValue([2, 4]);
    $[9] = getBreakpointValue;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== color || $[12] !== t5) {
    t6 = <Icon as={FaQuoteRight} boxSize={t5} color={color} opacity={0.5} />;
    $[11] = color;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <HStack>{t4}{t6}</HStack>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== getBreakpointValue) {
    t8 = getBreakpointValue(["sm", "lg", "xl"]);
    $[17] = getBreakpointValue;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== quote || $[20] !== t8) {
    t9 = <Text color="colorPalette.fg" fontFamily="longform" fontSize={t8} fontWeight={400} letterSpacing="normal">{quote}</Text>;
    $[19] = quote;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== getBreakpointValue) {
    t10 = getBreakpointValue([2, 4]);
    $[22] = getBreakpointValue;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== getBreakpointValue) {
    t11 = getBreakpointValue(["sm", "md"]);
    $[24] = getBreakpointValue;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Avatar.Fallback />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== personAvatarUrl) {
    t13 = <Avatar.Image src={personAvatarUrl} />;
    $[27] = personAvatarUrl;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t11 || $[30] !== t13) {
    t14 = <Avatar.Root boxShadow="base" size={t11}>{t12}{t13}</Avatar.Root>;
    $[29] = t11;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== getBreakpointValue) {
    t15 = getBreakpointValue(["md", "xl"]);
    $[32] = getBreakpointValue;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = personFullName ? personFullName : `${personFirstName} ${personLastName}`;
  let t17;
  if ($[34] !== t15 || $[35] !== t16) {
    t17 = <Text fontSize={t15} textStyle="labelLg">{t16}</Text>;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== getBreakpointValue) {
    t18 = getBreakpointValue(["badgeXs", "badgeSm"]);
    $[37] = getBreakpointValue;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const t19 = personTitle && companyName ? `${personTitle}, ${companyName}` : personTitle || companyName;
  let t20;
  if ($[39] !== t18 || $[40] !== t19) {
    t20 = <Text opacity={0.5} textStyle={t18}>{t19}</Text>;
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t17 || $[43] !== t20) {
    t21 = <VStack align="flex-start" gap={0}>{t17}{t20}</VStack>;
    $[42] = t17;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t10 || $[46] !== t14 || $[47] !== t21) {
    t22 = <HStack align="center" gap={t10} width="full">{t14}{t21}</HStack>;
    $[45] = t10;
    $[46] = t14;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== id || $[50] !== stackProps || $[51] !== t1 || $[52] !== t2 || $[53] !== t22 || $[54] !== t7 || $[55] !== t9) {
    t23 = <VStack alignItems="flex-start" alignSelf="stretch" borderRadius="2xl" boxShadow="sm" gap={t1} id={id} justify="space-between" padding={t2} width="full" {...stackProps}>{t7}{t9}{t22}</VStack>;
    $[49] = id;
    $[50] = stackProps;
    $[51] = t1;
    $[52] = t2;
    $[53] = t22;
    $[54] = t7;
    $[55] = t9;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  return t23;
};
export default OfficeHoursCard;